// ##########################################################################################
// Gallery Reveal Manager
// ==========================================================================================
// The Reveal manager object, defined by the return value of the function below, is a
// submodule of the JDA gallery module. This submodule is responsible for adding an 'active'
// class to each entry block DOM element as each one is moved into the correct position by a
// user scroll gesture. The addition of the active class is what causes the entry block
// to fade in / move up / appear nicely.
// ##########################################################################################

var galleryModule = app.mediator.getModule(MODULE_NAME__GALLERY);
galleryModule.injectSubModule('revealManager', function() {

	// =======================================================================
	// Module data
	// =======================================================================

    var helpers = app.helpers.funcs;
    var buildAnimationTimeout;

	// =======================================================================
	// Module methods
	// =======================================================================

    // 'Animates in' the supplied $block
    // This method should always be used whenever revealing a block.
    // Do not manually use $block.addClass('active') etc, as
    // it is tightly coupled to an implementation and will not call
    // onRevealComplete() when done.
    function revealBlock($block) {
        var activeEntryBlockSelector = galleryModule.getSelectorClass('activeEntryBlock');
        $block.addClass(activeEntryBlockSelector);
        onRevealComplete();
    }

    // 'Animates in' the supplied $blocks
    function revealBlocks($blocks) {
        $blocks.each(function(blockK, block) {
            var $block = $(block);
            revealBlock($block);
        });
    }

    // 'Animates in' all blocks that are present in the DOM
    function revealAll() {
        var blockSelector = galleryModule.getSelectorClass('entryBlock');
        var $blocks = galleryModule.getRootElem().find('.' + blockSelector);
        revealBlocks($blocks);
    }

    // 'Animates in' all blocks that occupy a position that is visible by the screen,
    // or above this position.
    var revealAllAboveFold = helpers.throttler(function () {

        var entryBlockManager = galleryModule.getSubModule('entryBlockManager');
        var $rootElem = galleryModule.getRootElem();
        var entryBlockSelector = galleryModule.getSelectorClass('entryBlock');
        var activeEntryBlockSelector = galleryModule.getSelectorClass('activeEntryBlock');

        var $hiddenItems = $rootElem.find('.' + entryBlockSelector).not('.' + activeEntryBlockSelector);
        var bottomOfWindow = $(window).scrollTop() + $(window).height();
        var breakpoint = helpers.getScreenSize();
        var biteDistanceFactor = 1;
        if (breakpoint == app.helpers.screenBreakpoints.xs) biteDistanceFactor = 1.2;
        $hiddenItems.each(function (k, block) {
            var $block = $(block);
            var blockHeight = entryBlockManager.getBlockHeight();
            var bottomOfBlock = $block.offset().top + blockHeight;
            if (bottomOfWindow >= (bottomOfBlock - (blockHeight * biteDistanceFactor))) {
                revealBlock($block);
            }
        });
    }, 200);

    // Function that always runs whenever an animated reveal transition completes.
    // (See functions above, which call this function).
    var onRevealComplete = helpers.throttler(function onRevealComplete() {
        var numberOfItemsInMemory = galleryModule.getSubModule('dataManager').getEntriesData().length;
        var numberOfItemsShown = getNumberOfRevealedBlocks();
        if (numberOfItemsShown == numberOfItemsInMemory && galleryModule.getSubModule('dataManager').hasFetchedAllEntries()) {
            galleryModule.onAllItemsShown();
        }
    }, 200);

    function getNumberOfRevealedBlocks() {
        var entryBlockSelector = galleryModule.getSelectorClass('entryBlock');
        var activeEntryBlockSelector = galleryModule.getSelectorClass('activeEntryBlock');
        var $visibleItems = galleryModule.getRootElem().find('.' + entryBlockSelector + '.' + activeEntryBlockSelector);
        return $visibleItems.length;
    }

    // Adds a class to the gallery module root node, that will cause all the entires to
    // transition in, in a kind of flurry. (Each subsequent entry gets revealed about 50ms after
    // the one before it).
    function temporarilyAddBuildAnimationClass() {
        galleryModule.getRootElem().addClass(galleryModule.getSelectorClass('buildAnimation'));
        clearTimeout(buildAnimationTimeout);
        buildAnimationTimeout = setTimeout(function() {
            galleryModule.getRootElem().removeClass(galleryModule.getSelectorClass('buildAnimation'));
        }, 1000);
    }

    // The restoring position class is intended to be added to the gallery module root element when
    // the gallery module is asynchronously fetching more than 30 entries - i.e. When the user has
    // used the back button to go back to the gallery page, but we want them to be in the same scroll
    // position as before.
    // The class is designed to be picked up by CSS that will make the loading mask
    // have fixed positioning or similar, so that the user sees it (rather than just a blank white page)
    // even though they have been scrolled down.
    function addRestoringPositionClass() {
        galleryModule.getRootElem().addClass(galleryModule.getSelectorClass('restoringPosition'));
    }

    function removeRestoringPositionClass() {
        galleryModule.getRootElem().removeClass(galleryModule.getSelectorClass('restoringPosition'));
    }

	// =======================================================================
	// Public API
	// =======================================================================

	return {
        revealAll: revealAll,
        revealAllAboveFold: revealAllAboveFold,
        onRevealComplete: onRevealComplete,
        getNumberOfRevealedBlocks: getNumberOfRevealedBlocks,
        temporarilyAddBuildAnimationClass: temporarilyAddBuildAnimationClass,
        addRestoringPositionClass: addRestoringPositionClass,
        removeRestoringPositionClass : removeRestoringPositionClass 
	};
});